module.exports = __webpack_public_path__ + "static/media/newLogo.be9b30aa.png";